import { COLORS_FAMILY_KEY } from '@/constants/colors-family-key';
import { useSearchParams } from 'next/navigation';
import { createPortal } from 'react-dom';

const CategoryNoIndex = props => {
  const { filterState } = props;
  const searchParams = useSearchParams();
  const filterCount = filterState.length;
  const searchParamKeys = Array.from(searchParams.keys());
  const onlyHasColorFilter = searchParamKeys.every(x => x === 'color' || x === COLORS_FAMILY_KEY);

  return filterCount > 3 || (searchParamKeys.length !== 0 && !onlyHasColorFilter)
    ? createPortal(
        <meta
          name='robots'
          content='noindex, nofollow'
        />,
        document.head,
      )
    : null;
};

export default CategoryNoIndex;
